export default (getter, mutation, mutationValueConverter) => {
  return {

    get () {
      return this.$store.getters[getter]
    },

    set (value) {
      this.$store.commit(mutation, mutationValueConverter ? mutationValueConverter(value) : value)
    }

  }
}
